import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { t, toggleLanguage, isTraditional } from './i18n'

import './assets/styles/global.css'
const app = createApp(App)

// 全局提供国际化方法
app.provide('t', t)
app.provide('toggleLanguage', toggleLanguage)
app.provide('isTraditional', isTraditional)

app.use(router)
app.mount('#app')
